import * as types from "./mutation-types";

const actions = {
  toggleMarked({ commit }, arg) {
    commit("toggleMarked");
  },
  togglePointPanel({ commit }, arg) {
    commit("togglePointPanel");
  },
  bindTime({ commit }, arg) {
    commit("bindTime", arg);
  },
  changeTask({ commit }, arg) {
    commit("changeTask", arg);
  },
};

export default actions;
